import moment from 'moment'

export default () => moment.localeData().longDateFormat('ll')
